class Fetcher {
  constructor() {
    this.categories = [];
    this.categoryTypes = [];
  }

  FETCH_INTERVAL = 600_000 // 10 minutes in milliseconds

  cleanParams(params, getters) {
    if (params.ids) {
      const uniqueIds = this.removeExistingAndDuplicateAttachments(params.ids, getters);
      params.ids = uniqueIds;
    }
    return params;
  }

  removeExistingAndDuplicateAttachments(ids, getters) {
    if (ids) {
      const uniqueIds = [];
      for (const id of ids) {
        if (!id || uniqueIds.includes(id)) {
          continue;
        }
        const existingAttachment = getters.get[id];
        if (!existingAttachment) {
          uniqueIds.push(id);
        }
      }
      return uniqueIds;
    }
  }

  shouldFetchCategory(categoryId) {
    const previousFetch = this.categories.find(cat => cat.categoryId === categoryId);
    if (previousFetch) {
      return Date.now > (previousFetch.lastFetchedAt + Fetcher.FETCH_INTERVAL);
    }
    return true;
  }

  shouldFetchCategoryType(categoryTypeId) {
    const previousFetch = this.categoryTypes.find(cat => cat.categoryTypeId === categoryTypeId);
    if (previousFetch) {
      return Date.now > (previousFetch.lastFetchedAt + Fetcher.FETCH_INTERVAL);
    }
    return true;
  }

  trackCategoryFetch(categoryId) {
    this.categories.push({ categoryId, lastFetchedAt: Date.now() });
  }

  trackCategoryTypeFetch(categoryTypeId) {
    this.categoryTypes.push({ categoryTypeId, lastFetchedAt: Date.now() });
  }

  validateParams(params) {
    // This ensures we don't send an empty array of ids are removing duplicates and existing attachments
    if (Array.isArray(params.ids) && params.ids.length < 1) {
      return false;
    }
    // Check to see if the category or category type was fetched recently
    if (params.categoryId) {
      const shouldFetch = this.shouldFetchCategory(params.categoryId);
      if (shouldFetch) {
        this.trackCategoryFetch(params.categoryId);
      } else {
        return false;
      }
    }

    if (params.categoryTypeId) {
      const shouldFetch = this.shouldFetchCategoryType(params.categoryTypeId);
      if (shouldFetch) {
        this.trackCategoryTypeFetch(params.categoryTypeId);
      } else {
        return false;
      }
    }

    // This maps over the keys in params and makes sure that there is at least one valid param and that the params is a truthy value
    const validParams = ['ids', 'categoryTypeId', 'categoryId'];
    return Object.keys(params).some(param => validParams.includes(param) && params[param]) ;
  }
}

export default Fetcher;
